export function isNullOrEmpty(values) {
  return values === undefined || values === null || values.length === 0
}
export function isNullOrWhitespace(value) {
  return value === undefined || value === null || value === ''
}
export function isNull(value) {
  return value === undefined || value === null
}
export function isNullOrZero(value) {
  return value === undefined || value === null || value === 0
}
export function listTreeId(list, isRoot, Id) {
  const rList = [] as any
  for (let i = 0; i < list.length; i++) {
    const row = {} as any
    row.Id = list[i].Id
    row.ParentId = list[i].ParentId
    row.route = list[i].route
    if (isNullOrWhitespace(list[i].ParentId)) {
      row.sectionTitle = list[i].sectionTitle
      row.svgIcon = 'media/icons/duotune/art/art002.svg'
      row.fontIcon = list[i].fontIcon
    } else {
      row.heading = list[i].sectionTitle
    }

    if (isRoot) {
      if (isNull(row.ParentId)) {
        const c = listTreeId(list, false, row.Id)
        if (!isNull(c) && c.length > 0) {
          row['sub'] = c
        }
        rList.push(row)
      }
    } else {
      if (!isNull(row.ParentId) && Id === row.ParentId) {
        const cC = listTreeId(list, false, row.Id)
        if (!isNull(cC) && cC.length > 0) {
          row['sub'] = cC
        }
        rList.push(row)
      }
    }
  }
  return rList
}

export default { listTreeId }
